export const SET_GLOBAL_PROPERTY = "SET_GLOBAL_PROPERTY";
export const NAVIGATE_TO_PAGE = "NAVIGATE_TO_PAGE";
export const PUSH_ERROR = "PUSH_ERROR";
export const POP_ERROR = "POP_ERROR";
export const PUSH_SUCCESS = "PUSH_SUCCESS";
export const POP_SUCCESS = "POP_SUCCESS";

export const LOGIN = "LOGIN";
export const IMPERSONATE = "IMPERSONATE";
export const LOGOUT = "LOGOUT";

export const StatesArray = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CT', 'CO', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD',
  'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA',
  'VT', 'WA', 'WI', 'WV', 'WY']

export const MapConstants = {
  styles: [{
    stylers: [{ saturation: -100 }]
  }],
  foodIcon: {
    iconUrl: '/img/cw-eat-drink-pin.svg',
    iconSize: [30, 30],
    iconAnchor: [15, 30]
  },
  campusIcon: {
    iconUrl: '/img/cw-university-activity-pin.svg',
    iconSize: [30, 30],
    iconAnchor: [15, 30]
  },
  attractionIcon: {
    iconUrl: '/img/cw-attractions-pin.svg',
    iconSize: [30, 30],
    iconAnchor: [15, 30]
  },
  defaultMarker: {
    html: '<i class="fas fa-map-marker-alt fa-3x"></i>',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [160, 20],
    className: 'map-marker'
  },
  activeMarker: {
    html: '<i class="fas fa-map-marker-alt fa-3x active"></i>',
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [160, 20],
    className: 'map-marker'
  },
  foodFilters: [
    { displayName: 'Bars', searchTerm: 'bars' },
    { displayName: 'Breakfast', searchTerm: 'breakfast' },
    { displayName: 'Breweries', searchTerm: 'breweries' },
    { displayName: 'Groceries', searchTerm: 'groceries' },
    { displayName: 'Pizza', searchTerm: 'pizza' },
    { displayName: 'Restaurants', searchTerm: 'restaurants' },
    { displayName: 'Sports Bars', searchTerm: 'sports bars' }
  ],
  campusFilters: [
    { displayName: 'Admissions', searchTerm: 'admissions office' },
    { displayName: 'Arena', searchTerm: 'arena' },
    { displayName: 'Stadium', searchTerm: 'stadium' },
    { displayName: 'Fan Gear', searchTerm: 'fan gear' }
  ],
  attractionFilters: [
    { displayName: 'Shopping - Boutique', searchTerm: 'boutique' },
    { displayName: 'Shopping - Center', searchTerm: 'shopping center' },
    { displayName: 'Theaters', searchTerm: 'theaters' },
    { displayName: 'Parks', searchTerm: 'recreational parks' },
    { displayName: 'Museums', searchTerm: 'museums' }
  ]
}
export const REVIEW_TYPE_CLEAN = 'Cleanliness';
export const REVIEW_TYPE_VALUE = 'Value';
export const REVIEW_TYPE_LOC = 'Location';
export const REVIEW_TYPE_COMM = 'Communication';
export const REVIEW_TYPE_OVR = 'Overall Experience';

export const REVIEW_USER_TYPES = [
  REVIEW_TYPE_CLEAN,
  REVIEW_TYPE_COMM,
  REVIEW_TYPE_OVR
];
export const REVIEW_LISTING_TYPES = [
  REVIEW_TYPE_CLEAN,
  REVIEW_TYPE_VALUE,
  REVIEW_TYPE_LOC,
  REVIEW_TYPE_COMM
];
